module.exports = __webpack_public_path__ + "img/1359603534.b9c255be.jpg";